import { fromJS } from 'immutable';
import { sortBy, noop } from 'lodash';
import { useEffect, useState } from 'react';

import { getMetaError, getClassNames } from 'shared/functions';
import { SelectV5 } from 'shared/ui/SelectV5/SelectV5';

import { defaultFilterOptions, filterArrayValue } from './functions';

export const RenderSelect = (props) => {
  const { input, meta, options = [], onChangeValue, onInputChange, isFixedOption, ...rest } = props;
  const immutableMode = !!input.value?.toJS;
  const jsValue = immutableMode ? input.value.toJS() : input.value;
  const multi = rest.multi || false;
  const [localValue, setLocalValue] = useState(
    Array.isArray(jsValue) ? filterArrayValue(jsValue ?? [], options, rest.valueKey) : jsValue,
  );
  const { label } = rest;
  const valueKey = rest.valueKey || 'id';
  const labelKey = rest.labelKey || 'label';
  const error = getMetaError(meta);
  const prefixOrPostfixSet = rest.postfix || rest.prefix;

  const [memoizedOptions, setMemoizedOptions] = useState(options);
  useEffect(() => {
    setMemoizedOptions((prev) => (options.length > prev.length ? options : prev));
  }, [options]);

  useEffect(() => {
    if (Array.isArray(jsValue)) {
      setLocalValue(filterArrayValue(jsValue, memoizedOptions, valueKey));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(jsValue), memoizedOptions, valueKey]);

  return (
    <div id={`${input.name}-wrapper`} data-testid={input.name} className={getClassNames('form-group', rest.formClass)}>
      {label && <label className={getClassNames('control-label', rest.labelClass)}>{label}</label>}
      <div className={getClassNames(rest.valueClass, (rest.prefix || rest.postfix) && 'input-group')}>
        {rest.prefix && <span className="input-group-addon">{rest.prefix}</span>}
        <SelectV5
          {...rest}
          id={input.name}
          noResultsText={rest.noResultsText || translate('No results found')}
          value={multi ? sortBy(localValue, 'name') : jsValue}
          valueKey={valueKey}
          labelKey={labelKey}
          options={options}
          placeholder={rest.placeholder || translate('Select...')}
          closeOnSelect={!multi}
          filterOptions={rest.filterOptions || defaultFilterOptions(valueKey, labelKey)}
          onInputChange={(inputValue) => {
            if (onInputChange) {
              onInputChange(inputValue, localValue);
            }
          }}
          onChange={(changedValue) => {
            // input.onChange is called with ID, if value is needed - pass onChangedValue
            if (onChangeValue) {
              onChangeValue(changedValue && changedValue.toJS ? changedValue.toJS() : changedValue);
            }
            let newValue;
            const optionalFromJS = immutableMode ? fromJS : (value) => value;
            if (rest.typeahead) {
              newValue = optionalFromJS(changedValue);
            } else if (changedValue) {
              newValue = multi ? optionalFromJS(changedValue) : changedValue[valueKey];
            } else {
              newValue = changedValue;
            }
            const checkedNewValue = multi && newValue === null ? [] : newValue;
            input.onChange(checkedNewValue);
          }}
          isFixedOption={isFixedOption}
        />
        {rest.postfix && (
          <span
            className={getClassNames('input-group-addon', rest.postfixClass)}
            onClick={rest.postfixOnClick || noop}
            style={{
              cursor: rest.postfixOnClick ? 'pointer' : '',
            }}
          >
            <span className={getClassNames(rest.postfixAddonClass)}>{rest.postfix}</span>
          </span>
        )}
        {!prefixOrPostfixSet && error && <div className="errorMsg">{error}</div>}
      </div>
      {prefixOrPostfixSet && error && <div className="errorMsg">{error}</div>}
    </div>
  );
};
